// predictionHelpers.js

export const defaultPrediction = {
    newPrediction: false,
    selectCountry: null,
    electionTypeData: { state: null, type: null },
    prediction: null,
    freshPredict: false,
    showNext: false,
};

export const setStep = (step, payload = {}) => {
    switch (step) {
        case "newPrediction":
            return { ...defaultPrediction, newPrediction: true };

        case "countrySelected":
            return {
                ...defaultPrediction,
                newPrediction: true,
                selectCountry: payload,
            };

        case "electionTypeSelected":
            return {
                ...defaultPrediction,
                newPrediction: true,
                selectCountry: payload.country,
                electionTypeData: payload.electionTypeData,
            };

        case "fullPrediction":
            return {
                ...defaultPrediction,
                newPrediction: true,
                selectCountry: payload.country,
                electionTypeData: payload.electionTypeData,
                prediction: payload.prediction,
            };

        case "reset":
        default:
            return { ...defaultPrediction };
    }
};
